import { computed as s, toValue as d, getCurrentInstance as b, ref as m, onMounted as w } from "vue";
import { createUUID as x } from "./index228.js";
function _(u) {
  return s(() => !!u.value);
}
function B(u = {}) {
  var n, f;
  const l = v((n = u.validation) == null ? void 0 : n.pattern), c = d(u.autoFocus), o = (f = b()) == null ? void 0 : f.proxy, a = m(!1), e = m(null), g = x("input-");
  let i;
  const r = s(() => a.value && (o == null ? void 0 : o.$props).modelValue !== "");
  w(() => {
    var t;
    c && ((t = e == null ? void 0 : e.value) == null || t.focus());
  });
  function v(t) {
    return t ? new RegExp(t) : void 0;
  }
  function p(t) {
    return l && t !== "" && !l.test(t);
  }
  function F(t) {
    !(t.target instanceof HTMLInputElement) && !(t.target instanceof HTMLTextAreaElement) || (p(t.target.value) && (t.target.value = d(u.initialValue) ?? ""), o == null || o.$emit("update:modelValue", t.target.value));
  }
  function T() {
    a.value = !0, o == null || o.$emit("focus");
  }
  function V() {
    i = window.setTimeout(() => {
      a.value = !1, o == null || o.$emit("blur"), clearTimeout(i);
    }, 100);
  }
  function E(t) {
    t.target.blur();
  }
  function $() {
    var t;
    r.value && (clearTimeout(i), o == null || o.$emit("update:modelValue", ""), (t = e == null ? void 0 : e.value) == null || t.focus());
  }
  return {
    hasFocus: a,
    input: e,
    showReset: r,
    uuid: g,
    onInput: F,
    onBlur: V,
    onFocus: T,
    reset: $,
    onEnter: E
  };
}
export {
  B as addFormFieldBehavior,
  _ as addFormFieldErrorHandling
};
